<!-- 销售记账操作 -->
<template>
    <div>
        <div>
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <el-form label-width="150px" id="mainInfo" size="mini" class="baseForm" :show-message="false">
                                    <!-- 主要信息 -->
                                    <div v-if="scope.index == 0">
                                        <el-row ref="baseForm" v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :label="formOneValue.showField" :prop="formOneValue.entityField" v-if="formOneValue.isShow == 1" :key="formOneKey"
                                                              :rules="formOneValue.isRequired == 1 && isReviewReq == true ? [{ required: formOneValue.isChange == 1, trigger: ['blur', 'change'] }] : []">
                                                    <!-- 销售订单号 -->
                                                    <el-input v-if="formOneValue.entityField == 'woamId'" :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo[formOneValue.entityField]"
                                                              @focus="openExComponents(formOneValue.extractId)"></el-input>
                                                    <!-- 销售单位 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'cmId'" :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo.cmName"></el-input>
                                                    <!-- 业务员 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'opmId'" :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo.opmName"></el-input>
                                                    <!-- 业务部门 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'depId'" :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo.depName"></el-input>
                                                    <!-- 是否WMS管理 -->
                                                    <el-radio-group disabled v-else-if="formOneValue.entityField == 'isWms'" v-model="sendDataInfo[formOneValue.entityField]">
                                                        <el-radio-button :label="0">否</el-radio-button>
                                                        <el-radio-button :label="1">是</el-radio-button>
                                                    </el-radio-group>
                                                    <!-- 对方业务员 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'salesId'" :disabled="formOneValue.isChange == 0" v-model.trim="sendDataInfo.salesName"></el-input>
                                                    <!-- 第二记账人 -->
                                                    <el-input v-else-if="formOneValue.entityField == 'twoAudit'" v-model.trim="sendDataInfo.twoAuditName" :maxlength="$store.state.inputLength"
                                                              :disabled="formOneValue.isChange == 0"></el-input>

                                                    <!-- 记账日期 -->
                                                    <df-date :isdisabled="formOneValue.isChange == 0" v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"></df-date>
                                                    <el-input disabled v-else-if="formOneValue.entityField == 'woamOpposalesman'" v-model.trim="sendDataInfo.woamOpposalesmanName"></el-input>
                                                    <el-input :disabled="formOneValue.isChange == 1 ? false : true" v-else v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row ref="baseForm" v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item :key="formOneKey" :label="formOneValue.showField + ':'" v-if="formOneValue.isShow == 1">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField) + ':'"></label>
                                                    <span v-if="formOneValue.fieldType == 'date'">
                                                        {{ $common.getLocalTime(sendDataInfo[formOneValue.entityField]) }}
                                                    </span>
                                                    <span v-else-if="formOneValue.entityField == 'cmId'">{{ sendDataInfo.cmName }}</span>
                                                    <span v-else-if="formOneValue.entityField == 'opmId'">{{ sendDataInfo.opmName }}</span>
                                                    <span v-else-if="formOneValue.entityField == 'depId'">{{ sendDataInfo.depName }}</span>
                                                    <span v-else-if="formOneValue.entityField == 'salesId'">{{ sendDataInfo.salesName }}</span>
                                                    <span v-else-if="formOneValue.entityField == 'twoAudit'">{{ sendDataInfo.twoAuditName }}</span>
                                                    <span v-else-if="formOneValue.entityField == 'woamOpposalesman'">{{ sendDataInfo.woamOpposalesmanName }}</span>
                                                    <span v-else-if="formOneValue.entityField == 'isWms'">{{ sendDataInfo.cmName ==1?'是':'否'}}</span>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{ sendDataInfo[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                        {{ getValue(sendDataInfo[formOneValue.entityField],formOneValue.entityField, formOneValue.fieldType, formOneValue.formatterContent)}}
                                                    </span>
                                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>

                                    </div>
                                    <!-- 辅助信息 -->
                                    <div v-if="scope.index == 1">
                                        <el-row>
                                            <el-col :span="12" v-for="(formOneValue, formOneKey) in scope.row.jurconfigform" :key="formOneKey">
                                                <el-form-item v-if="formOneValue.isShow == 1" :label="formOneValue.showField">
                                                    <!-- 起运时间 -->
                                                    <el-date-picker disabled v-if="formOneValue.entityField == 'psaiDeptime'" v-model="sendDataInfo.wosupinfor[formOneValue.entityField]" type="date"
                                                                    format="yyyy 年 MM 月 dd 日" value-format="timestamp"></el-date-picker>
                                                    <!-- 预到货时间 -->
                                                    <el-date-picker disabled v-else-if="formOneValue.entityField == 'psaiExptime'" v-model="sendDataInfo.wosupinfor[formOneValue.entityField]" type="date"
                                                                    format="yyyy 年 MM 月 dd 日" value-format="timestamp"></el-date-picker>
                                                    <!-- 货主 -->
                                                    <el-input disabled v-else-if="formOneValue.entityField == 'coId'" v-model.trim="sendDataInfo.wosupinfor.coName"></el-input>

                                                    <el-input disabled v-else v-model.trim="sendDataInfo.wosupinfor[formOneValue.entityField]">
                                                    </el-input>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </div>
                                </el-form>
                                <!-- 明细 -->
                                <el-form :inline="true" size="mini">
                                    <el-table :data="sendDataInfo.desuWobkeDtailAdd" border style="width: 100%" :height="mxHeight" class="toReviewTable" ref="multipleTable" size="mini">
                                        <template v-for="(formOneValue, formOneKey) in mxForm">
                                            <el-table-column :key="formOneKey" :prop="formOneValue.entityField" :label="formOneValue.showField" show-overflow-tooltip v-if="formOneValue.isShow == 1"
                                                             :min-width="formOneValue.fieldWeight">
                                                <template slot-scope="scope">
                                                    <!-- 显示通用名称 -->
                                                    <span v-if="formOneValue.entityField == 'bgmId'">
                                                        {{ sendDataInfo.desuWobkeDtailAdd[scope.$index].bgmName }}
                                                    </span>
                                                    <!-- 有效期 -->
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo.desuWobkeDtailAdd[scope.$index][formOneValue.entityField]">
                                                            {{$common.getLocalTime(sendDataInfo.desuWobkeDtailAdd[scope.$index][formOneValue.entityField])}}
                                                        </span>
                                                    </span>
                                                    <!-- 生产日期 -->
                                                    <!-- 第二复合人 -->
                                                    <el-tag size="mini" v-else-if="formOneValue.entityField == 'isReview'">
                                                        {{ scope.row.isReview == 1 ? '是' : '否' }}
                                                    </el-tag>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(scope.row[formOneValue.riftField])">{{ scope.row[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else>
                                                        {{ sendDataInfo.desuWobkeDtailAdd[scope.$index][formOneValue.entityField] }}
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </template>
                                    </el-table>
                                </el-form>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <tree v-if="dataActionBox.actionType == 2" ref="tree" @tabHeight="(val) => { mxHeight = val }"></tree>
                <div class="foot">
                    <div>
                        <el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary" @click="showPrintPlan">打印</el-button>
                        <el-button type="primary" @click="initActionBox('sendDataInfo')" v-if="dataActionBox.actionType != 2">取消</el-button>
                        <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType != 2">保存</el-button>
                    </div>
                    <el-form :inline="true" :model="sendDataInfo" class="demo-form-inline ml" v-if="footForm">
                        <el-form-item :label="itemV.chineseField" v-for="(itemV, itemK) in footForm" :key="itemK">
                            <el-button type="success">{{ sendDataInfo[itemV.entityField] }}</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>

        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
            <ExtractionScheme ref="extractionScheme" :ppId="ppId" :id="exId" @TranData="getExData" @getWidth="getExWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>

    </div>

</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from 'number-precision'
import ExtractionScheme from "../byComponents/ExtractionScheme.vue";
export default {
    name: 'bookkeepingOrderAction',
    props: ['actionData'],
    //import引入的组件需要注入到对象中才能使用
    components: { ExtractionScheme },
    data() {
        //这里存放数据
        return {
            dialogFormVisible: false,
            dataActionBox: {
                showStatus: false,
                openMode: 'ltr' || 'rtl',
                boxTitle: '新增' || '编辑'
            },
            sendDataInfo: {
                "accountTime": 0,
                "accounter": 0,
                "cmId": 0,
                "cmName": "",
                "depId": 0,
                "depName": "",
                "isWms": 0,
                "opmId": 0,
                "opmName": "",
                "totalCount": 0,
                "totalMoney": 0,
                "totalNumber": 0,
                "woamId": "",
                "woamRemark": "",
                "woamSaledate": 0,
                "desuWobkeDtailAdd": [
                    {
                        "batchno": "",
                        "bgmId": 0,
                        "bgmName": "",
                        "bgsId": 0,
                        "expidate": 0,
                        "gross": 0,
                        "manufacturer": "",
                        "money": 0,
                        "outRate": 0,
                        "placeorigin": "",
                        "price": 0,
                        "prodate": 0,
                        "psmoney": 0,
                        "psprice": 0,
                        "returnNum": 0,
                        "rowno": 0,
                        "spec": "",
                        "sterBatchno": "",
                        "woadId": 0,
                        "woadPnumber": 0,
                        "woadWcost": 0,
                        "wobkedId": 0,
                        "wobkedReserves1": "",
                        "wobkedReserves2": "",
                        "wobkedReserves3": "",
                        "wobkedReserves4": "",
                        "wobkedReserves5": "",
                        "wobkedReserves6": "",
                        "wobkemId": "",
                        "worcdId": 0
                    }
                ],
                "wobkemExecuterName": "",
                "wobkemId": "",
                "wobkemReserves1": "",
                "wobkemReserves2": "",
                "wobkemReserves3": "",
                "wobkemReserves4": "",
                "wobkemReserves5": "",
                "wobkemReserves6": "",
                "wobkemState": 0,
                "worcmId": "",
                "wosiId": 0,
                "wosupinfor": {
                    "coId": 0,
                    "coName": "",
                    "credit": "",
                    "dismode": "",
                    "payMethod": "",
                    "settleMethod": "",
                    "wosiId": 0,
                    "wosiReserves1": "",
                    "wosiReserves2": "",
                    "wosiReserves3": "",
                    "wosiReserves4": "",
                    "wosiReserves5": "",
                    "wosiReserves6": ""
                }
            },
            // reviewDialogFormVisible:false,
            review: {
                twoAudit: '',
                pwd: ''
            },
            reviewRules: {
                twoAudit: [
                    { required: true, message: '请选择记账人', trigger: 'change' }
                ],
                pwd: [
                    { required: true, message: '请输入密码', trigger: 'blur' }
                ]
            },
            showTabs: '',
            formDataList: [],
            dictionariesData: {},
            userOneList: [],

            reviewUserInfo: {
                opmId: '',
                passWord: '',
                selectIndex: 0,
            },
            isReviewReq: false,
            actionIndex: '',
            ishowRew: true,
            exTitle: '',//缓存提取
            exWidth: '',
            DialogExtract: false,
            ppId: '',
            exId: '',
            mxHeight: 0,
            tabForm: [],
            mxForm: [],
            footForm: []
        };
    },
    //监听属性 类似于data概念
    computed: {
    },
    //监控data中的数据变化
    watch: {
        'sendDataInfo.desuWobkeDtailAdd': {

            handler: function (newValue, oldValue) {
                this.sendDataInfo.desuWobkeDtailAdd = newValue
                // console.log(newValue)
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'smIntype') {
                this.dictionariesDatas.forEach(item => {
                    if (item.diValue == val) {
                        str = item.diName
                    }
                })
            } else if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        tabHeight(val) {
            this.mxHeight = val
        },
        showPrintPlan() { // 打印方法
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.actionData.orderId, this.actionData.printSouce, this.actionData.printJurId)
            } else {
                return
            }
        },
        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2) this.$parent.$parent.toDetail(orderId)
            else this.$parent.$parent.$parent.toDetail(orderId)
        },
        // 触发提取方案
        openExComponents(e) {
            // console.log(e);
            this.exId = e;
            this.DialogExtract = true;
        },

        // 获取 提取单数据
        async getExData(res) {
            let val = JSON.parse(JSON.stringify(res))
            console.log('提取', val);
            if (val != "" || val != undefined) {
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        this.sendDataInfo.desuWobkeDtailAdd = val.arrlistbychen;
                        // this.sendDataInfo.desuWobkeDtailAdd.forEach((items,keys)=>{
                        // 	this.sendDataInfo.desuWobkeDtailAdd[keys].reviewStatus = 0
                        // 	if(val.isReview == 1){
                        // 		this.sendDataInfo.desuWobkeDtailAdd[keys].reviewStatus = 1
                        // 	}
                        // })
                    } else {
                        this.sendDataInfo[key] = val[key];
                    }
                }
                let responseData = await this.$http.getWosupinfor({ ids: [val.wosiId] })
                if (responseData && responseData.status == 200) {
                    this.sendDataInfo.wosupinfor = responseData.result;
                } else {
                    this.$message({
                        message: responseData.message,
                        type: 'error'
                    })
                }
                this.sendDataInfo.accountTime = new Date().getTime()

                // console.log(this.sendDataInfo);
            } else {
                this.$message({
                    message: '未拿到数据',
                    type: 'error'
                })
            }
            this.DialogExtract = false
        },
        getExWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },

        //保存
        async sendDataAction() {
            if (!this.sendDataInfo.woamId) {
                this.$message({
                    message: '请选择销售单进行记账',
                    type: 'error'
                });
                return false
            }
            if (!this.sendDataInfo.accountTime) {
                this.$message({
                    message: '请选择记账日期',
                    type: 'error'
                });
                return false
            }
            console.log('send', this.sendDataInfo);
            var responseData = await this.$http.addSalesBookkeeping(this.sendDataInfo)
            if (responseData && responseData.status == 200) {
                this.$message({
                    message: '操作成功',
                    type: 'success'
                });
                this.$emit('drawerCancel')

            } else {
                this.$message({
                    message: responseData.message,
                    type: 'error'
                });
            }
        },
        initActionBox() {
            this.$confirm('确定取消' + this.dataActionBox.boxTitle + '吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$emit('drawerCancel')
                this.init()
            }).catch(() => { })
        },
        init() {
            for (let key in this.sendDataInfo) {
                if (key == 'wosupinfor') {
                    this.sendDataInfo[key] = {}
                    for (let sonOne in this.sendDataInfo[key]) {
                        this.sendDataInfo[key][sonOne] = ''
                    }
                } else {
                    this.sendDataInfo[key] = ''
                }
            }
            this.sendDataInfo.desuWobkeDtailAdd = []
        },

        //父级传入
        openBox() {
            this.dataActionBox.actionType = this.actionData.cate
            this.formDataList = this.actionData.formData
            var oldData = this.actionData.oldData
            this.showTabs = this.actionData.formData[0].jciName
            if (this.dataActionBox.actionType == 0) {
                this.init();
                this.dataActionBox.boxTitle = "创建销售复核单";
                this.dataActionBox.openMode = "ltr";
            } else if (this.dataActionBox.actionType == 2) {
                this.dataActionBox.boxTitle = '查看信息'
                var dataInfo = JSON.parse(JSON.stringify(oldData))
                for (let key in dataInfo) {
                    this.sendDataInfo[key] = dataInfo[key]
                    if (key == 'wobkedetailInfos') this.sendDataInfo.desuWobkeDtailAdd = dataInfo[key]
                }
            }
            this.filterMainField()
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight()
                    } else {
                        this.$refs['tree'].init(this.sendDataInfo.wobkemId)
                        this.mxHeight = this.$common.getHeight()
                    }
                }, 100)
            })

        },
        // 过滤表单不同类型
        filterMainField() {
            var mainFormList = []
            this.formDataList.forEach(item => {
                if (item.jciType == 1) {
                    mainFormList.push(item)
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item.jurconfigform))
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform))
                }
            })
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key))
                this.tabForm[i].jurconfigform = []
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) this.tabForm[i].jurconfigform.push(key.jurconfigform[index])
                }
            })
            console.log(this.tabForm)
            console.log(this.mxForm)
            console.log(this.footForm)
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.$nextTick(() => {
            this.openBox()
        })
        this.ppId = "worcmId";
        // this.getSpecialUser()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() {
    }, //生命周期 - 创建之前
    beforeMount() {
    }, //生命周期 - 挂载之前
    beforeUpdate() {
    }, //生命周期 - 更新之前
    updated() {
    }, //生命周期 - 更新之后
    beforeDestroy() {
    }, //生命周期 - 销毁之前
    destroyed() {
    }, //生命周期 - 销毁完成
    activated() {
    }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.table_button_box {
    height: 200px;
    background-color: red;
}

.table_content_box {
    overflow-y: auto;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.mb {
    margin-bottom: 0;
}

::v-deep .toReviewTable tr td:first-child .cell,
::v-deep .toReviewTable tr th:first-child .cell {
    text-align: center;
}

::v-deep .toReviewTable .el-checkbox__inner {
    width: 18px;
    height: 18px;
}

::v-deep .toReviewTable .el-checkbox__inner::after {
    height: 8px;
    left: 6px;
    top: 2px;
    width: 5px;
}

::v-deep
    .toReviewTable
    .el-checkbox__input.is-indeterminate
    .el-checkbox__inner::before {
    height: 2px;
    left: 0;
    right: 0;
    top: 7px;
}

::v-deep .el-tabs--border-card_new .el-tabs__item:nth-child(3) {
    display: none;
}
</style>